import React, { Component } from 'react'
import axios from 'axios'
import DemandItem from '../Demand/DemandItem'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import { Link } from 'react-router-dom'
import ReactGA from 'react-ga'

class DemandList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            list: null,
        }
    }

    componentDidMount() {
        this.loadList()
    }

    loadList = () => {
        const { cookies } = this.props
        axios
            .get(`${BACKEND_HOST}/rfis/?project_id=${cookies.get('project')}&resReq=REQ`, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                if (res.data.data.length > 5) {
                    const list = []

                    for (let i = 0; i < 5; i += 1) {
                        list.push(res.data.data[i])
                    }
                    this.setState({ list })
                } else {
                    this.setState({ list: res.data.data })
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    renderList = () => {
        const List = this.state.list.map((item) => {
            return <DemandItem item={item} key={item._id} />
        })
        return List
    }

    render() {
        console.log(this.state)
        return (
            <div className="demand_wrap">
                <div className="title_wrap common_wrap">
                    <Link
                        to={'/demand/'}
                        onClick={() => {
                            ReactGA.event({ category: '대시보드_건축주', label: '건축주의 요청', action: '전체보기' })
                        }}>
                        <div className="more_btn">
                            더보기
                            <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10">
                                <path
                                    fill="none"
                                    fillRule="evenodd"
                                    stroke="#A2A7AE"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.3"
                                    d="M1.56.95L6.06 5l-4.5 4.05"
                                />
                            </svg>
                        </div>
                    </Link>
                    <h1>
                        건축주 요청 <span className="pc_v">진행현황</span>
                    </h1>
                </div>

                <div className="demand_list_bottom common_wrap">
                    <div className="list_title">
                        <p className="title">요청</p>
                        <p className="name pc_v_impo">처리자</p>
                        <p className="date pc_v_impo">등록일</p>
                        <p className="status">상태</p>
                    </div>
                    <div className="list_wrap">
                        {this.state.list && this.state.list.length !== 0 ? (
                            this.renderList()
                        ) : (
                            <div className="no_list_wrap">
                                <svg xmlns="http://www.w3.org/2000/svg" width="52" height="57" viewBox="0 0 52 57">
                                    <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                                        <path
                                            stroke="#DEE3EB"
                                            strokeWidth="3"
                                            d="M4.5 2h25.086L50.5 18.575V52a3 3 0 0 1-3 3h-43a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3z"
                                        />
                                        <path stroke="#F5F7FA" strokeWidth="2.4" d="M33.5 30l-15 15M18.5 30l15 15" />
                                        <path
                                            stroke="#DEE3EB"
                                            strokeWidth="3"
                                            d="M33.5 30l-15 15M18.5 30l15 15M29.5 3v17.506h12"
                                        />
                                    </g>
                                </svg>
                                <p>등록된 내용이 없습니다.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(DemandList)



// WEBPACK FOOTER //
// ./Src/Components/Dashboard/OwnerDemandList.js